import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const DangerLiner24 = (props)=>/*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12.0004 8.24994C12.4146 8.24994 12.7504 8.58573 12.7504 8.99994V13.9999C12.7504 14.4142 12.4146 14.7499 12.0004 14.7499C11.5862 14.7499 11.2504 14.4142 11.2504 13.9999V8.99994C11.2504 8.58573 11.5862 8.24994 12.0004 8.24994Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.995 15.9999C11.4427 15.9999 10.995 16.4477 10.995 16.9999C10.995 17.5522 11.4427 17.9999 11.995 17.9999H12.004C12.5563 17.9999 13.004 17.5522 13.004 16.9999C13.004 16.4477 12.5563 15.9999 12.004 15.9999H11.995Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.8776 22.16H5.94034C4.04058 22.16 2.5076 21.4747 1.74228 20.1709C0.977392 18.8678 1.12491 17.1947 2.04441 15.5363L5.16461 9.91593L8.10443 4.63626C9.06799 2.89897 10.4504 1.84247 12.0003 1.84247C13.5503 1.84247 14.9323 2.89832 15.8959 4.63563L21.9561 15.5459C22.8761 17.2054 23.0205 18.8789 22.2543 20.1815C21.488 21.4842 19.9559 22.17 18.0603 22.17H12.0003C11.9585 22.17 11.9175 22.1665 11.8776 22.16ZM12.0003 3.34247C11.2005 3.34247 10.2327 3.89136 9.41625 5.36368L6.47607 10.644L3.35626 16.2636C2.59577 17.6353 2.62829 18.7171 3.03589 19.4116C3.44308 20.1052 4.3701 20.66 5.94034 20.66H12.0003C12.0422 20.66 12.0832 20.6634 12.1231 20.67H18.0603C19.6248 20.67 20.5527 20.1157 20.9614 19.421C21.3702 18.726 21.4043 17.6442 20.6444 16.2736L14.5848 5.36431C13.7684 3.89199 12.8002 3.34247 12.0003 3.34247Z",
                fill: "currentColor"
            })
        ]
    }));
